import api from "api";
import React, { Fragment, useEffect, useState } from "react";
import Header from "component/Header/Header";
import Footer from "component/Footer/Footer.js";
import HomeSlider from "component/HomeSlider/HomeSlider";
import BlockHeader from "component/BlockHeader/BlockHeader";
import LoginBox from "component/LoginBox/LoginBox";
import fancybox from "component/Fancybox/Fancybox";
import { InitiativeSlider, InitiativeListGrouped } from '../../component/InitiativeList';
import { RisingStar } from "component/RisingStar";
import { TalentPoolSlider } from "component/TalentPool";
import stateMap from "../../store/stateMap";
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import _ from "lodash";
import InitialsAvatar from 'react-initials-avatar';
import { Waypoint } from "react-waypoint";
import { SetTokenizeUser } from "store/dispatcher";
import "./PageHome.scss"
import { FAQList } from "component/FAQ";
import { PagesListSlider } from "component/Pages";
import { PageCredential } from "component/PageCredential";


const HomeCrowdbeesInitiatives = (props) => {
    
    return (
        <div className="crowdbees-initiatives">
            <ul className="initiative-groups">
                <li className="initiative-group type-research">
                    <div className="wrapper">
                        <div className="group-information">
                            <h2 className="group-name">Research Activity</h2>
                            <div className="group-desc leading-text">Collaboration between people from similar or other disciplines. Collaborative research help researcher to exchange ideas and create a higher research quality.</div>
                        </div>
                        
                        <div className="view-all-container">
                            <Link
                                to={{
                                    pathname : "research"
                                }}
                            >View Initiative</Link>
                        </div>
                    </div>
                </li>
                <li className="initiative-group type-event">
                    <div className="wrapper">
                        <div className="group-information">
                            <h2 className="group-name">Event</h2>
                            <div className="group-desc leading-text">Are you looking for visitors for your event, or meet the best crew to run your event.</div>
                        </div>
                        <div className="view-all-container">
                            <Link
                                to={{
                                    pathname : "event"
                                }}
                            >View Initiative</Link>
                        </div>
                    </div>
                </li>
                <li className="initiative-group type-talent">
                    <div className="wrapper">
                        <div className="group-information">
                            <h2 className="group-name">Talent Team</h2>
                            <div className="group-desc leading-text">Build your dream team by finding the right talent for your project. Choose the talent that suitable with your needs based on their relevant qualifications, skills, and expertise..</div>
                        </div>
                        <div className="view-all-container">
                            <Link
                                to={{
                                    pathname : "talent"
                                }}
                            >View Initiative</Link>
                        </div>
                    </div>
                </li>
                
            </ul>
        </div>
    )
}

const HomeCrowdbeesAds = (props) => {
    return (
        
        <div className="crowdbees-ads" style={{
            backgroundImage : 'url(https://images.unsplash.com/photo-1662581872342-3f8e0145668f?ixlib=rb-1.2.1&dl=dell-Yu0e-xuWoFI-unsplash.jpg&w=1920&q=80&fm=jpg&crop=entropy&cs=tinysrgb)'
        }}>
            <div className="ads-info color-white mb-4">
                <h2 className="title ">Crowdbees exist to help bring creative projects to life.</h2>
                
                <div className="flex flex-wrap">
                    {
                        props.user === false && 
                        <button 
                            className="btn btn-orange"
                            onClick={() => {
                                fancybox(<LoginBox/>);
                            }}
                        >Login</button>
                    }
                </div>
            </div>
            <HomeCrowdbeesInitiatives/>
        </div>
    )
}

const PageHome = connect(stateMap)((props) => {
    const [waypointLatest, setWaypointLatest] = useState(false);
    const [waypointRisingStars, setWaypointRisingStars] = useState(false);
    const [waypointFAQ, setWaypointFAQ] = useState(false);
    const [waypointPages, setWaypointPages] = useState(false);

    return (
        <>
            <div id="home-latest-projects">
                <Waypoint onEnter={() => {
                    setWaypointLatest(true);
                }}/>
                <div className="container">
                    <div className="">
                        <BlockHeader 
                            title="Latest Initiative" 
                            desc="Discover the various exciting initiatives that are being and have been built through Crowdbees."
                            link={{
                                pathname : '/initiative'
                            }} />
                        {
                            waypointLatest && 
                            <InitiativeSlider initiatives_args={{
                                paged               : 1
                                ,posts_per_page     : 10
                            }} />
                        }
                    </div>
                    
                    
                    <div className="mt-5">
                        <HomeCrowdbeesAds user={props.auth.user} />
                    </div>
                    <Waypoint onEnter={() => {
                        setWaypointRisingStars(true)
                    }}/>
                    <div className="mt-5">
                        <BlockHeader 
                            title="Our Rising Stars" 
                            desc="Our users with the best ratings"
                            link={{
                                pathname : '/rising-star'
                            }}    
                        />
                            
                        {
                            waypointRisingStars &&    
                            <RisingStar listArgs={{
                                posts_per_page : 4
                            }}/>
                        }
                    </div>
                </div>
            </div>
            <div className="container ">
                <Waypoint onEnter={() => {
                    setWaypointPages(true);
                }}/>
                <BlockHeader title="Pages" desc="Visit the official pages of BINUS and find interesting initiatives for you" link={{
                    pathname : "/page"
                }}/>
                {
                    waypointPages && <PagesListSlider/>
                }
            </div>
            <Waypoint onEnter={() => {
                setWaypointFAQ(true)
            }}/>
            <div className="container">
                <BlockHeader link={{
                    pathname : "/faq"
                }} title="FAQ" desc="Have Question ? Read our most frequently asked question"/>
                {
                    waypointFAQ && <FAQList sticky="1"/>
                }
            </div>
        </>
    )
});

const PageHomeLoggedin = connect(stateMap)((props) => {
    const [waypointLatest, setWaypointLatest] = useState(false);
    const [waypointRisingStars, setWaypointRisingStars] = useState(false);
    const [waypointRec, setWaypointRec] = useState(false);
    const [waypointPool, setWaypointPool] = useState(false);
    const [waypointPages, setWaypointPages] = useState(false);

    return (
        <>
            <div id="home-latest-projects">
                <div className="container">
                    <BlockHeader 
                        title="On Going Initiative" 
                        desc="Quickly access your active initiative."/>
                    <InitiativeListGrouped
                        list_args={{
                            member_id : props.auth.user.UserID
                            ,incomplete : 1
                        }}
                    />
                    <Waypoint onEnter={() => {
                        setWaypointLatest(true);
                    }}/>
                    <div className="mt-5">
                        <BlockHeader 
                            title="Latest Initiative" 
                            desc="Discover the various exciting initiatives that are being and have been built through Crowdbees."
                            link={{
                                pathname : '/initiative'
                            }} />
                        {
                            waypointLatest && 
                            <InitiativeSlider initiatives_args={{
                                paged               : 1
                                ,posts_per_page     : 10
                            }} />
                        }
                    </div>
                    <div className="mt-5">
                        <Waypoint onEnter={() => {
                            setWaypointPool(true);
                        }}/>
                        <BlockHeader title="Meet The Talent" desc="Meet various talents to work together" link={{
                            pathname : "/talent-pool"
                        }}/>
                        {
                            waypointPool && 
                            <TalentPoolSlider list_args={{
                                posts_per_page : 4
                                ,include_user_score : 1
                                ,include_bio : 1
                                ,sortby         : 'ActivationDate'
                                ,sort           : 'DESC'
                            }}/>
                        }
                    </div>
                    <div className="mt-5">
                        <Waypoint onEnter={() => {
                            setWaypointPages(true);
                        }}/>
                        <BlockHeader title="Pages" desc="Visit the official pages of BINUS and find interesting initiatives for you" link={{
                            pathname : "/page"
                        }}/>
                        {
                            waypointPages && <PagesListSlider/>
                        }
                    </div>
                    <div className="mt-5">
                        <HomeCrowdbeesAds user={props.auth.user}/>
                    </div>                    
                </div>
            </div>

            <Waypoint onEnter={() => {
                setWaypointRec(true)
            }}/>
            {
                waypointRec &&
                <div id="home-proposed-projects">
                    <div className="container">
                        <BlockHeader 
                            title="Initiatives you might like" 
                            desc="Here are some initiatives that might suit you, join and work hand in hand with fellow BINUSIAN"/>
                        <InitiativeSlider endpoint="/Initiative/Recommendation" token={`Bearer ${props.auth.token}`} />
                    </div>
                </div>
            }

            <div className="container"> 
                <Waypoint onEnter={() => {
                    setWaypointRisingStars(true)
                }}/>
                <BlockHeader 
                    title="Our Rising Stars" 
                    desc="Our users with the best ratings"
                    link={{
                        pathname : '/rising-star'
                    }}    
                />
                {
                    waypointRisingStars && 
                    <RisingStar listArgs={{
                        posts_per_page : 4
                    }}/>
                }
            </div>
        </>
    )
});

export default connect(stateMap, {SetTokenizeUser})((props) => {
    const [headerBG, setHeaderBG]   = useState(false);
    
    return(
        <>
            <Header background={headerBG}>
                <PageCredential title="Home"/>
                {
                    !props.auth.fetching && (
                        !props.auth.user 
                        ? 
                        <HomeSlider
                            onChanged={(slide) => {
                                setHeaderBG(slide.pic)
                            }}
                        /> 
                        :
                        <div className="user-home-intro relative container">
                            <span className="image-box circle square">
                                {
                                    !props.auth.user.UserPhoto ? <InitialsAvatar name={props.auth.user.UserDisplayName} /> 
                                    : <img src={props.auth.user.UserPhoto}/>
                                }
                            </span>
                            <h1 className="text-xl bold color-white">Welcome {props.auth.user.UserDisplayName}</h1>
                            <div className="flex flex-wrap mt-lg h-center">
                                <div>
                                    <Link className="btn btn-orange btn-mini" to={{
                                        pathname : "/create"
                                    }}>Add Initiatives</Link>&nbsp;
                                </div>
                                <div>
                                    <Link className="btn btn-orange btn-reverse btn-mini" to={{
                                        pathname : "/profile"
                                    }}>Complete Portofolios</Link>&nbsp;
                                </div>
                            </div>
                        </div>
                    ) 
                }
            </Header>
            {
                !props.auth.fetching && (
                    props.auth.user ? <PageHomeLoggedin/> : <PageHome/>
                )
            }
            <Footer/>
        </>
    )
});